import * as ons from 'onsenui';
export var onsPlatform = ons.platform;
//# sourceMappingURL=platform.js.map